module.exports = __webpack_public_path__ + "assets/img/marketLinkage.db58b028.png";